import axios from '@service'
import {SYSTEM_INITIALIZATION} from './api'
import {HTTP_ERR_SUCCESS} from "@/constant/api_status";
import {ERROR_DEFAULT_HTTP_REQUEST_FAIL} from "@/constant/error";

/**
 * 系统初始化参数查询
 * @param payload
 * @param config
 * @returns {Promise<*>}
 */
export default async function systemInitializationService(payload = {}, config = {}) {
    const param = {...SYSTEM_INITIALIZATION, ...config, params: payload}
    const {data} = await axios(param)
    if (data.code === HTTP_ERR_SUCCESS) {
        return data.data
    } else {
        throw new Error(data.msg || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}